import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from "../../store/reducers";

export default (store) => ({
  path: 'loyalty-tiers',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const loyaltyTierContainer = require('./containers/LoyaltyTierContainer').default
      const {loadBrandNamesReducer} = require('../SalesAnalytics/modules/salesAnalytics')
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer})

      cb(null, loyaltyTierContainer)
      /* Webpack named bundle   */
    }, 'loyaltyTier')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LoyaltyTier/index.js